
import { Card, IconButton, ModalWindow } from "@/shared/ui";
import { defineComponent } from "vue";
import { Stunt as StuntType } from "@/types";
import { Stunt } from "@/entities";
import { AddNewAndEditStunt } from "@/features";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";

export default defineComponent({
	name: "StuntsSection",
	components: { AddNewAndEditStunt, ModalWindow, IconButton, Stunt, Card },
	setup() {
		const store = useCharactersStore();

		const { characters, current } = storeToRefs(store);

		const { updateStunts } = store;

		return {
			characters,
			current,
			updateStunts,
		};
	},
	data() {
		return {
			modal: false,
		};
	},
	methods: {
		add(stunt: StuntType) {
			this.updateStunts([...this.characters[this.current].stunts, stunt]);
		},
		update(stunt: StuntType, id: number) {
			const newStunts = [...this.characters[this.current].stunts];
			newStunts.splice(id, 1, stunt);
			this.updateStunts(newStunts);
		},
		remove(id: number) {
			this.updateStunts(
				this.characters[this.current].stunts.filter(
					(e: StuntType, i: number) => i !== id
				)
			);
		},
	},
});
